import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getApp } from 'firebase/app'
import { getFirestore, doc, setDoc, orderBy, limit, query,collection,getDocs } from 'firebase/firestore'
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import '../assets/css/addprojects.css'

const AddProjects = () => {
  const [projectName, setProjectName] = useState('')
  const [projectCategory, setProjectCategory] = useState('')
  const [projectDescription, setProjectDescription] = useState('')
  const [projectImages, setProjectImages] = useState([])
  const [projectDate, setProjectDate] = useState(''); // State for project date
  const [profileImage, setProfileImage] = useState(null)
  const [error, setError] = useState('')
  const navigate = useNavigate()
  const app = getApp()
  const db = getFirestore(app)
  const storage = getStorage(app)
  const auth = getAuth()

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      if (!user) {
        navigate('/login')
      }
    })

    return () => unsubscribe()
  }, [auth, navigate])

  const handleProfileImageChange = e => {
    setProfileImage(e.target.files[0])
  }

  const handleImageChange = e => {
    setProjectImages(Array.from(e.target.files))
  }

  const handleSubmit = async e => {
    e.preventDefault()
    if (
      !projectName ||
      !projectCategory ||
      !profileImage ||
      projectImages.length === 0
    ) {
      setError('All fields are required.')
      return
    }
    const user = auth.currentUser
    if (!user) {
      setError('User is not authenticated.')
      return
    }
    try {
      const projectsQuery = query(collection(db,'Projects'), orderBy('order','desc'),limit(1))
      const querySnapshot = await getDocs(projectsQuery)
      let maxOrder = 0 
      querySnapshot.forEach(doc => {
        maxOrder = doc.data().order
      })
      const newOrder = maxOrder + 1
      const profileImageRef = ref(
        storage,
        `images/${projectName}/profile_${profileImage.name}`
      )
      await uploadBytes(profileImageRef, profileImage)
      const profileImageUrl = await getDownloadURL(profileImageRef)

      // Upload additional images
      const imageUrls = await Promise.all(
        projectImages.map(async image => {
          const imageRef = ref(
            storage,
            `images/${projectName}/additionals_${image.name}`
          )
          await uploadBytes(imageRef, image)
          return await getDownloadURL(imageRef)
        })
      )

      const projectData = {
        name: projectName,
        category: projectCategory,
        description: projectDescription,
        profileImage: profileImageUrl,
        images: imageUrls,
        createdAt: new Date().toISOString(),
        date: new Date(projectDate).toISOString().split('T')[0], // Format date to YYYY-MM-DD
        order: newOrder
      }

      await setDoc(doc(db, 'Projects', projectName), projectData)
      alert('Project added successfully.')
      navigate('/manageprojects')
    } catch (error) {
      setError('Error adding project: ' + error.message)
    }
  }

  return (
    <div className='max-w-2xl mx-auto p-4 bg-white shadow-md rounded-lg add-projects-container'>
      <h1 className='text-2xl font-bold mb-4'>Add Project</h1>
      {error && <p className='text-red-500'>{error}</p>}
      <form onSubmit={handleSubmit} className='space-y-4'>
        <div>
          <label className='block text-sm font-medium text-gray-700'>
            Project Name:
          </label>
          <input
            type='text'
            value={projectName}
            onChange={e => setProjectName(e.target.value)}
            className='mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm'
          />
        </div>
        <div>
          <label className='block text-sm font-medium text-gray-700'>
            Category:
          </label>
          <select
            value={projectCategory}
            onChange={e => setProjectCategory(e.target.value)}
            className='mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm'
          >
            <option value=''>Select a category</option>
            <option value='Architecture Design'>Architecture Design</option>
            <option value='Interior Design'>Interior Design</option>
            <option value='Construction Design'>Constructions Design</option>
            <option value='Architecture & Interior Design'>
              Architecture & Interior Design
            </option>
            <option value='Architecture & Constructions Design'>
              Architecture & Constructions Design
            </option>
            <option value='Interior & Constructions Design'>
              Interior & Constructions Design
            </option>
          </select>
        </div>
        <div>
          <label className='block text-sm font-medium text-gray-700'>
            Description:
          </label>
          <textarea
            value={projectDescription}
            onChange={e => setProjectDescription(e.target.value)}
            className='mt-1 block w-full h-32 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm'
          />
        </div>
        <div>
          <label className='block text-sm font-medium text-gray-700'>
            Profile Image:
          </label>
          <input
            type='file'
            onChange={handleProfileImageChange}
            className='mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm'
          />
        </div>
        <div>
          <label className='block text-sm font-medium text-gray-700'>
            Images:
          </label>
          <input
            type='file'
            multiple={true}
            onChange={handleImageChange}
            className='mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm'
          />
        </div>
        <div>
          <label>Project Date:</label>
          <input
            type="date"
            value={projectDate}
            onChange={(e) => setProjectDate(e.target.value)}
          />
        </div>
        <button
          type='submit'
          className='inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
        >
          Save
        </button>
      </form>
    </div>
  )
}

export default AddProjects
